export default {
    CURRENT_SLIDER_STATUS : '/slider',
    CURRENT_THEME: '/theme',
};